import React from 'react'
import {
  BaseModal,
  BaseModalProps,
} from '@/components/modals/base-modal/base-modal'
import { Button } from '@mui/material'

interface Props extends BaseModalProps {
  submitText?: string
  onSubmit: (data: any) => void
  cancelText?: string
  onCancel?: () => void
}

const AlertModal: React.FC<Props> = ({
  onSubmit,
  submitText = 'אישור',
  cancelText,
  onCancel,
  ...props
}) => {
  return (
    <BaseModal
      {...props}
      actions={
        <>
          {cancelText && <Button onClick={onCancel}>{cancelText}</Button>}
          <Button onClick={onSubmit}>{submitText}</Button>
        </>
      }
    />
  )
}

export default AlertModal
